import { useQuery } from 'react-query';
import { getAllEnergyData } from '../services/energyService';
import {queryClient} from "../services/queryClient";
import useSearchState from "./useSearch";

export const getCacheKeyForEnergy = (address) => {
  const addressQuery = encodeURIComponent(
    `${address?.flat_number ? address?.flat_number + ' ' : ''}${address?.address}`,
  );

  return `energy_${(address?.postcode)}_${addressQuery}`;
}

const useEnergy = (address, forceRefresh = false) => {
  const {searchState} = useSearchState()
  const savedSearchId = searchState?.savedSearchId

  const cacheKey =  getCacheKeyForEnergy(address);
  const currentCacheKey= ['energyData', cacheKey, savedSearchId];
    ///api/energy/
  //const pastData = queryClient.getQueryData(currentCacheKey);

  const enabled = Boolean(address?.postcode);
  return useQuery(
    currentCacheKey,
    () => getAllEnergyData(address, forceRefresh),

    {
      enabled,
      staleTime: Infinity,
      initialData:() => queryClient.getQueryData(currentCacheKey),
      refetchOnMount:false,
      refetchOnWindowFocus:false,
    },
  );
};

export default useEnergy;
